import { logAppError } from 'Helpers/logger'
import { type Getter, type Setter } from 'jotai'
import { getFilterTypes } from 'Pages/unifiedFiltersListPage/services/filterTypes'
import { availFilterTypesAtom } from 'Pages/unifiedFiltersListPage/state/state'
import {
  errorUpdater,
  loaderUpdater,
  pageState,
  statusUpdater,
} from 'State/page'
import { changeFiltersQueryAndSearch } from './filters'

export const initPageCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  set(pageState, loaderUpdater(true))

  try {
    const filterTypes = getFilterTypes()

    set(availFilterTypesAtom, filterTypes)

    await changeFiltersQueryAndSearch(get, set, {
      types: filterTypes.map((t) => t.value),
    })
    set(pageState, statusUpdater('ready'))
  } catch (e) {
    console.error('### error', e)

    logAppError({
      Component: 'UnifiedFiltersListPage',
      Method: 'initPageCallback',
      appError: e instanceof Error ? e : undefined,
    })

    set(pageState, errorUpdater)
  }

  set(pageState, loaderUpdater(false))
}
